export default __webpack_public_path__ + "static/media/Flutter.358b3df3.png";